export const getConsent = () => {
  const didomi = getDidomi()
  const hasDidomiUserContentStatus = Object.hasOwnProperty(didomi, 'getUserConsentStatus')
  const { contentPersonalization, adsPersonalization, productResearch, vendorId, analytics } = didomiConfig
  return {
    contentPersonalization: hasDidomiUserContentStatus && didomi.getUserConsentStatus(contentPersonalization, vendorId),
    adsPersonalization: hasDidomiUserContentStatus && didomi.getUserConsentStatus(adsPersonalization, vendorId),
    analytics: hasDidomiUserContentStatus && didomi.getUserConsentStatus(analytics, vendorId),
    productResearch: hasDidomiUserContentStatus && didomi.getUserConsentStatus(productResearch, vendorId)
  }
}

export const setGtmConsent = (gtm, action) => {
  gtm('consent', action || 'default', getGtmConsent())
  if (window && window.dataLayer) {
    window.dataLayer.push({ event: 'consent-update' })
  }
}

export const didomiConfig = {
  vendorId: 'c:economiaa-ndEUAX3g',
  contentPersonalization: 'publishers-XWZ2b3AK',
  adsPersonalization: 'publishers-UPqtcgaE',
  analytics: 'publishers-Kqq3iPge',
  productResearch: 'publishers-jRQF2F4U'
}

const getGtmConsent = () => {
  const { contentPersonalization, adsPersonalization, analytics } = getConsent()
  return {
    ad_storage: adsPersonalization ? 'granted' : 'denied',
    analytics_storage: analytics ? 'granted' : 'denied',
    personalization_storage: contentPersonalization ? 'granted' : 'denied'
  }
}

const getDidomi = () => {
  if (window && window.Didomi) {
    return window.Didomi
  }
}
